import { render, staticRenderFns } from "./ReservationMenu.vue?vue&type=template&id=65dfe72b&"
import script from "./ReservationMenu.vue?vue&type=script&lang=js&"
export * from "./ReservationMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports